var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84998 2.50001C1.84998 2.14102 2.14099 1.85001 2.49998 1.85001H9.99998C10.359 1.85001 10.65 2.14102 10.65 2.50001C10.65 2.85899 10.359 3.15001 9.99998 3.15001H3.14998V9.50001C3.14998 9.85899 2.85896 10.15 2.49998 10.15C2.14099 10.15 1.84998 9.85899 1.84998 9.50001V2.50001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.15 2.50001C22.15 2.14102 21.859 1.85001 21.5 1.85001H14C13.641 1.85001 13.35 2.14102 13.35 2.50001C13.35 2.85899 13.641 3.15001 14 3.15001H20.85V9.50001C20.85 9.85899 21.141 10.15 21.5 10.15C21.859 10.15 22.15 9.85899 22.15 9.50001V2.50001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.15C21.859 22.15 22.15 21.859 22.15 21.5V14.5C22.15 14.141 21.859 13.85 21.5 13.85C21.141 13.85 20.85 14.141 20.85 14.5V20.85H14C13.641 20.85 13.35 21.141 13.35 21.5C13.35 21.859 13.641 22.15 14 22.15H21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84998 21.5C1.84998 21.859 2.14099 22.15 2.49998 22.15H9.99998C10.359 22.15 10.65 21.859 10.65 21.5C10.65 21.141 10.359 20.85 9.99998 20.85H3.14998V14.5C3.14998 14.141 2.85896 13.85 2.49998 13.85C2.14099 13.85 1.84998 14.141 1.84998 14.5V21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 7.50001H9.09998V9.10001H7.49998V7.50001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 5.00001H6.09998C5.49246 5.00001 4.99998 5.49249 4.99998 6.10001V10.4C4.99998 11.0075 5.49246 11.5 6.09998 11.5H10.4C11.0075 11.5 11.5 11.0075 11.5 10.4V6.10001C11.5 5.49249 11.0075 5.00001 10.4 5.00001ZM5.99998 6.10001C5.99998 6.04478 6.04475 6.00001 6.09998 6.00001H10.4C10.4552 6.00001 10.5 6.04478 10.5 6.10001V10.4C10.5 10.4552 10.4552 10.5 10.4 10.5H6.09998C6.04475 10.5 5.99998 10.4552 5.99998 10.4V6.10001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 7.50001V9.10001H16.6V7.50001H15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 5.00001H17.9C18.5075 5.00001 19 5.49249 19 6.10001V10.4C19 11.0075 18.5075 11.5 17.9 11.5H13.6C12.9925 11.5 12.5 11.0075 12.5 10.4V6.10001C12.5 5.49249 12.9925 5.00001 13.6 5.00001ZM13.6 6.00001C13.5447 6.00001 13.5 6.04478 13.5 6.10001V10.4C13.5 10.4552 13.5447 10.5 13.6 10.5H17.9C17.9552 10.5 18 10.4552 18 10.4V6.10001C18 6.04478 17.9552 6.00001 17.9 6.00001H13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 15H9.09998V16.6H7.49998V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 12.5H6.09998C5.49246 12.5 4.99998 12.9925 4.99998 13.6V17.9C4.99998 18.5075 5.49246 19 6.09998 19H10.4C11.0075 19 11.5 18.5075 11.5 17.9V13.6C11.5 12.9925 11.0075 12.5 10.4 12.5ZM5.99998 13.6C5.99998 13.5448 6.04475 13.5 6.09998 13.5H10.4C10.4552 13.5 10.5 13.5448 10.5 13.6V17.9C10.5 17.9552 10.4552 18 10.4 18H6.09998C6.04475 18 5.99998 17.9552 5.99998 17.9V13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 12.85V14.45H14.45V12.85H12.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.85H18.6V14.45H17V12.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9499 15V16.6H16.5499V15H14.9499Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 17H14.45V18.6H12.85V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17V18.6H18.6V17H17Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84998 2.50001C1.84998 2.14102 2.14099 1.85001 2.49998 1.85001H9.99998C10.359 1.85001 10.65 2.14102 10.65 2.50001C10.65 2.85899 10.359 3.15001 9.99998 3.15001H3.14998V9.50001C3.14998 9.85899 2.85896 10.15 2.49998 10.15C2.14099 10.15 1.84998 9.85899 1.84998 9.50001V2.50001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.15 2.50001C22.15 2.14102 21.859 1.85001 21.5 1.85001H14C13.641 1.85001 13.35 2.14102 13.35 2.50001C13.35 2.85899 13.641 3.15001 14 3.15001H20.85V9.50001C20.85 9.85899 21.141 10.15 21.5 10.15C21.859 10.15 22.15 9.85899 22.15 9.50001V2.50001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.15C21.859 22.15 22.15 21.859 22.15 21.5V14.5C22.15 14.141 21.859 13.85 21.5 13.85C21.141 13.85 20.85 14.141 20.85 14.5V20.85H14C13.641 20.85 13.35 21.141 13.35 21.5C13.35 21.859 13.641 22.15 14 22.15H21.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84998 21.5C1.84998 21.859 2.14099 22.15 2.49998 22.15H9.99998C10.359 22.15 10.65 21.859 10.65 21.5C10.65 21.141 10.359 20.85 9.99998 20.85H3.14998V14.5C3.14998 14.141 2.85896 13.85 2.49998 13.85C2.14099 13.85 1.84998 14.141 1.84998 14.5V21.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 7.50001H9.09998V9.10001H7.49998V7.50001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 5.00001H6.09998C5.49246 5.00001 4.99998 5.49249 4.99998 6.10001V10.4C4.99998 11.0075 5.49246 11.5 6.09998 11.5H10.4C11.0075 11.5 11.5 11.0075 11.5 10.4V6.10001C11.5 5.49249 11.0075 5.00001 10.4 5.00001ZM5.99998 6.10001C5.99998 6.04478 6.04475 6.00001 6.09998 6.00001H10.4C10.4552 6.00001 10.5 6.04478 10.5 6.10001V10.4C10.5 10.4552 10.4552 10.5 10.4 10.5H6.09998C6.04475 10.5 5.99998 10.4552 5.99998 10.4V6.10001Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.50001V9.10001H16.6V7.50001H15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 5.00001H17.9C18.5075 5.00001 19 5.49249 19 6.10001V10.4C19 11.0075 18.5075 11.5 17.9 11.5H13.6C12.9925 11.5 12.5 11.0075 12.5 10.4V6.10001C12.5 5.49249 12.9925 5.00001 13.6 5.00001ZM13.6 6.00001C13.5447 6.00001 13.5 6.04478 13.5 6.10001V10.4C13.5 10.4552 13.5447 10.5 13.6 10.5H17.9C17.9552 10.5 18 10.4552 18 10.4V6.10001C18 6.04478 17.9552 6.00001 17.9 6.00001H13.6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 15H9.09998V16.6H7.49998V15Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 12.5H6.09998C5.49246 12.5 4.99998 12.9925 4.99998 13.6V17.9C4.99998 18.5075 5.49246 19 6.09998 19H10.4C11.0075 19 11.5 18.5075 11.5 17.9V13.6C11.5 12.9925 11.0075 12.5 10.4 12.5ZM5.99998 13.6C5.99998 13.5448 6.04475 13.5 6.09998 13.5H10.4C10.4552 13.5 10.5 13.5448 10.5 13.6V17.9C10.5 17.9552 10.4552 18 10.4 18H6.09998C6.04475 18 5.99998 17.9552 5.99998 17.9V13.6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 12.85V14.45H14.45V12.85H12.85Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.85H18.6V14.45H17V12.85Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9499 15V16.6H16.5499V15H14.9499Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 17H14.45V18.6H12.85V17Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17V18.6H18.6V17H17Z",
    stroke: "currentColor",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode3);
export default __webpack_public_path__ + "static/media/qrCode3.c9785a1b.svg";
export { ForwardRef as ReactComponent };